import React, { ButtonHTMLAttributes } from 'react';
import styles from './button.module.scss';
import { Link } from '@reach/router';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
  state?: 'hover' | 'active' | 'focus';
  small?: boolean;
  href?: string;
}

export const Button: React.FC<Props> = ({ small, state, href, children, ...props }) => {
  const smallClass = small ? styles.small : '';
  const stateClass = state ? styles[state] : '';
  const Tag = href ? (href.includes('http') ? 'a' : Link) : 'button';
  let externalProps = null;
  if (href) {
    externalProps = {
      href,
      target: '_blank',
      rel: 'noopener noreferrer',
    };
  }

  return (
    <Tag className={`${styles.button} ${stateClass} ${smallClass}`} {...externalProps} to={href} {...props}>
      {children}
    </Tag>
  );
};
